module.exports = __webpack_public_path__ + "img/selected.96e46df2.svg";